import dynamic from 'next/dynamic'

export const CSR = dynamic(() => import('./CSRInner'), {
  ssr: false,
})
